import React from 'react';

const SelectGallery = () => {
    return (
        <div>
            
        </div>
    );
};

export default SelectGallery;
